import { DAY_RANGE } from './constants';
export function generateChartData(labelArray, datasets){
    return {
        labels: labelArray,
        datasets: datasets.map(dataset => ({
            type: 'line',
            label: dataset.label,
            data: dataset.data,
            borderColor: dataset.borderColor,
            backgroundColor: dataset.backgroundColor,
            yAxisID: dataset.yAxisID || 'y1',
            tension: 0.2,
            borderWidth: 1,
            pointRadius: 0,
            hidden: dataset.hidden || false,
            fill: dataset.fill || true,
            snapGaps: dataset.snapGaps || true,
        })),
    };
}
export function generateGraphOptions(args){
    return {
      responsive: true,
      maintainAspectRatio: false,
      layout:{
        padding: {
          bottom: 28,
        }
      },
      scales: {
        x:{
          type: 'time',
          ticks:{align:'start'},
          time: {
            unit: 'month',
            displayFormats: {
              hour:'HH:mm',
              day: 'EEE dd MMM, yy',
              week: 'EEE dd MMM, yy'
            },
            tooltipFormat: 'EEE dd MMM yyyy HH:mm',
          },
        },
        y1: {
          type: 'linear',
          position: 'left',
          beginAtZero: true,
          grid: {
            drawOnChartArea: false 
          },
          title:{
            display: true,
            text:args.y1Title
          }
        },
        y2: {
          type: 'linear',
          position: 'right',
          beginAtZero: true,
          grid: {
            drawOnChartArea: false 
          },
          title:{
            display: true,
            text:args.y2Title
          }
        },
      },
      plugins: {
        title:{
            display: true,
            text: args.title,
            font: {
              size: 20
            }
          },
          subtitle: {
            display: true,
            text: ''
        },
          legend:{
            display: false,
          },
          CrosshairPlugin:true,
          TooltipPlugin:true,
          tooltip:{
            mode: 'index',
            intersect: false,
            position: 'custom',
            backgroundColor: 'rgba(0,0,0,0.6)',
            callbacks: {
              title: function(items) {
                  items[0].tooltipTitle = items[0].label;
                  return null
              },
          },
          },
          zoom: {
            limits:{
                x:{
                    min: '',
                    max: '',
                    minRange: DAY_RANGE
                }
              },
            zoom: {
              wheel: {
                enabled: true, 
              },
              pinch: {
                enabled: true,
              },
              mode: 'x',
              onZoom: args.onZoom,
              onZoomComplete: args.onZoomComplete,
            },
            pan: {
              enabled: true,  
              mode: 'x',
              onPan: args.onPan,
              onPanComplete: args.onPanComplete,
            }
          },
        }
    }
}


export function dateToString(date){
    return date.toISOString().split('T')[0];
}